import { LoadingSpinner } from "@bluefalcon/components-package";
import { Carrier, CarrierCreateRequest, CarrierUpdateRequest } from "@bluefalcon/clients-management-client-fetch";
import { Box, Button, Flex, Input, Table, TableCaption, Tbody, Td, Th, Thead, Tr, useDisclosure } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { carriersService } from "../../services";
import { AddEditCarrierModal } from "../../modals/add-edit-carrier.modal";
import { Link } from "react-router-dom";

type CarriersTableProps = {};

export const CarriersTable = ({ }: CarriersTableProps) => {

    const [selectedCarrier, setSelectedCarrier] = useState<Carrier>();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [carriers, setCarriers] = useState<Carrier[]>([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [query, setQuery] = useState('');

    const fetchCarriers = async () => {
        setIsLoading(true);
        try {
            const { results, total: _total } = await carriersService.searchCarriers({
                query,
            });
            setCarriers(results);
            setTotal(_total);
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    };

    const handleCreate = async (data: CarrierCreateRequest) => {
        await carriersService.createCarrier(data);
        await fetchCarriers();
    };

    const handleEdit = async (carrierId: number, data: CarrierUpdateRequest) => {
        await carriersService.updateCarrierById(carrierId, data);
    };

    const handleDelete = async (carrierId: number) => {

    };

    const handleEditButtonClick = (carrier: Carrier) => {
        setSelectedCarrier(carrier);
        onOpen();
    };

    const handleAddButtonClick = () => {
        setSelectedCarrier(undefined);
        onOpen();
    };

    const search = async () => {
        await fetchCarriers();
    };

    useEffect(() => {
        fetchCarriers();
    }, []);

    if (isLoading) {
        return <LoadingSpinner />
    }

    return (
        <>
            <Flex mb={2}>
                <form onSubmit={search}>
                    <Flex>
                        <Input onChange={(e) => setQuery(e.target.value)} value={query} placeholder="search..." type={'search'} />
                        <Button type="submit" onClick={search} ml={2} colorScheme="primary">Search</Button>
                    </Flex>
                </form>
                <Button onClick={handleAddButtonClick} ml={'auto'} colorScheme="teal">Add Carrier</Button>
            </Flex>
            {carriers.length ? <Table variant="simple">
                <TableCaption textAlign={'left'}>Total Carriers: {total}</TableCaption>
                <Thead>
                    <Tr>
                        <Th>ID</Th>
                        <Th>Name</Th>
                        <Th>Actions</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {carriers.map((carrier) => (
                        <Tr key={carrier.id}>
                            <Td>{carrier.id}</Td>
                            <Td>{carrier.name}</Td>
                            <Td>
                                <Flex>
                                    <Button mr={2} size="sm" onClick={() => handleEditButtonClick(carrier)}>
                                        Edit
                                    </Button>
                                    <Button as={Link} to={`/carriers/${carrier.id}`} mr={2} size="sm">
                                        Details
                                    </Button>
                                </Flex>
                            </Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table> : <Box textAlign={'center'} mt={5}>
                No carriers found.
            </Box>}
            <AddEditCarrierModal
                modalState={isOpen}
                closeModal={onClose}
                carrier={selectedCarrier}
                handleAddCarrier={handleCreate}
                handleDeleteCarrier={handleDelete}
                handleEditCarrier={handleEdit}
            />
        </>
    )
};
